import { createReducer } from '@reduxjs/toolkit' ;
import { getAwsCognitoToken, getUserAttributesSuccess, getUserAttributesFailure, setUserNameAction, getAuthUser,
    updateAwsTokenSuccess, updateAwsTokenFailure, initializaMerchantState
 } from '../actions/amazonWebServicesAction';

const initialState = {
    awsCognito: {},
    loading: false,
    accessTokenError: {},
    code: '',
    userName: '',
	userEmail: '',
	isAdmin:'',
    authUser: false,
    userAttributes: null
}




const amazonWebServicesReducer = createReducer(initialState, (builder) => {
    builder
        .addCase(getAwsCognitoToken, (state, action) => {
            state.code = action.payload.code;
        }).addCase(updateAwsTokenSuccess, (state, action) => {
            state.awsCognito = action.payload.result;
        }).addCase(updateAwsTokenFailure, (state, action) => {
            state.err = action.payload.err;
        }).addCase(getUserAttributesSuccess, (state, action) => {
			state.userAttributes = action.payload.response;
            state.userName = action.payload.response.att.find(attr => attr.Name === `name`).Value;
            state.userEmail = action.payload.response.att.find(attr => attr.Name === `email`).Value;
            state.isAdmin = action.payload.response.isAdmin;
			sessionStorage.setItem('userName', state.userName );
			sessionStorage.setItem('userEmail', state.userEmail );
        }).addCase(getUserAttributesFailure, (state, action) => {
            state.userAttributes = action.message;
        }).addCase(setUserNameAction, (state, action) => {
            state.userName = action.payload.userName;
        }).addCase(getAuthUser, (state, action) => {
            state.authUser = action.payload.authUser;
        }).addCase(initializaMerchantState, (state, action) => {
            state = {
                awsCognito: {},
                loading: false,
                accessTokenError: {},
                code: '',
                userName: '',
                userEmail: '',
                isAdmin:'',
                authUser: false,
                userAttributes: null
            }
        }).addDefaultCase(() => { });
});
export default amazonWebServicesReducer;
